import { RedoButton } from "@redotech/arbiter/buttons/redo-button";
import { Flex } from "@redotech/arbiter/flex";
import { RedoSpinner } from "@redotech/arbiter/loading/redo-spinner";
import { Text } from "@redotech/arbiter/text";
import XCloseIcon from "@redotech/redo-icons/x-close.svg";
import { WalkthroughNavButtons } from "@redotech/redo-merchant-app-common/walkthrough/walkthrough-nav-buttons";
import { memo } from "react";
import { TourStep } from "./tour-types";

export const TourBar = memo(function TourBar({
  step,
  stepIndex,
  totalSteps,
  next,
  back,
  close,
  loading,
}: {
  step: TourStep;
  stepIndex: number;
  totalSteps: number;
  next(): void;
  back(): void;
  close(): void;
  loading: boolean;
}) {
  return (
    <Flex
      align="center"
      aria-label="Product tour"
      bgColor="primary"
      borderColor="secondary"
      borderRadius="xl"
      borderWidth="1px"
      bottom="3xl"
      data-testid="tour-bar"
      gap="lg"
      left="3xl"
      maxW="2xl"
      mx="auto"
      position="fixed"
      px="lg"
      py="md"
      right="3xl"
      role="region"
      shadow="lg"
      style={{ zIndex: 1701 }}
    >
      <Flex dir="column" gap="xs" grow={1} minW="none">
        <Flex align="center" gap="sm">
          <Text
            fontSize="sm"
            fontWeight="semibold"
            overflow="hidden"
            textOverflow="ellipsis"
            whiteSpace="nowrap"
          >
            {step.title}
          </Text>
          {loading && <RedoSpinner size="xs" />}
        </Flex>
        <Text fontSize="xs" textColor="secondary">
          {step.description}
        </Text>
      </Flex>
      <Flex align="center" gap="sm" shrink={0}>
        <Text fontSize="xs" textColor="secondary" whiteSpace="nowrap">
          {stepIndex + 1} / {totalSteps}
        </Text>
        <WalkthroughNavButtons
          back={back}
          next={next}
          stepIndex={stepIndex}
          totalSteps={totalSteps}
        />
        <RedoButton
          aria-label="Close tour"
          hierarchy="tertiary"
          IconLeading={XCloseIcon}
          onClick={close}
          size="sm"
        />
      </Flex>
    </Flex>
  );
});
